module.exports = __webpack_public_path__ + "img/stone3.277934d9.jpg";